import { Link, useNavigate } from "react-router-dom";
import { X, Trash2, Minus, Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { productById, fmt } from "../data/store";

export const CartDrawer = () => {
  const { items, setQty, remove, drawerOpen, setDrawerOpen } = useCart();
  const navigate = useNavigate();
  const lines = items.map((i) => ({ ...i, p: productById(i.id) })).filter((l) => l.p);
  const subtotal = lines.reduce((s, l) => s + l.p.price * l.qty, 0);

  if (!drawerOpen) return null;
  return (
    <div className="fixed inset-0 z-[60]">
      <div className="absolute inset-0 bg-black/40" onClick={() => setDrawerOpen(false)} data-testid="cart-drawer-overlay" />
      <div data-testid="cart-drawer" className="absolute right-0 top-0 bottom-0 w-full sm:w-[420px] bg-white shadow-xl flex flex-col animate-in slide-in-from-right duration-200">
        <div className="flex items-center justify-between p-4 border-b border-[#E2E2E2]">
          <h2 className="text-lg font-bold">Grozs ({lines.reduce((s, l) => s + l.qty, 0)})</h2>
          <button onClick={() => setDrawerOpen(false)} data-testid="cart-drawer-close" aria-label="Aizvērt"><X size={22} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {lines.length === 0 && <p className="text-sm text-[#6B6B6B] text-center py-10" data-testid="cart-drawer-empty">Grozs ir tukšs.</p>}
          {lines.map((l) => (
            <div key={l.id} className="flex gap-3" data-testid={`drawer-item-${l.id}`}>
              <img src={l.p.image} alt={l.p.name} className="w-16 h-16 object-cover rounded bg-[#F5F5F5]" />
              <div className="flex-1 min-w-0">
                <Link to={`/prece/${l.id}`} onClick={() => setDrawerOpen(false)} className="text-sm font-semibold line-clamp-2 hover:text-[#111111]">{l.p.name}</Link>
                <div className="flex items-center gap-3 mt-1.5">
                  <div className="flex items-center border border-[#E2E2E2] rounded-md">
                    <button onClick={() => setQty(l.id, l.qty - 1)} className="p-1.5 hover:bg-[#F5F5F5]" data-testid={`drawer-qty-minus-${l.id}`}><Minus size={12} /></button>
                    <span className="text-sm w-7 text-center font-semibold">{l.qty}</span>
                    <button onClick={() => setQty(l.id, l.qty + 1)} className="p-1.5 hover:bg-[#F5F5F5]" data-testid={`drawer-qty-plus-${l.id}`}><Plus size={12} /></button>
                  </div>
                  <span className="text-sm font-bold">{fmt(l.p.price * l.qty)}</span>
                  <button onClick={() => remove(l.id)} className="ml-auto text-[#6B6B6B] hover:text-[#D0121A]" data-testid={`drawer-remove-${l.id}`} aria-label="Dzēst"><Trash2 size={15} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-[#E2E2E2] p-4 space-y-3">
          <div className="flex justify-between text-sm"><span className="text-[#6B6B6B]">Starpsumma (ar PVN)</span><span className="font-bold" data-testid="drawer-subtotal">{fmt(subtotal)}</span></div>
          <button onClick={() => { setDrawerOpen(false); navigate("/noformesana"); }} disabled={lines.length === 0} data-testid="drawer-checkout-btn"
            className="w-full bg-[#D0121A] hover:bg-[#A80D14] disabled:opacity-50 text-white font-bold py-3 rounded-md transition-colors">Uz apmaksu</button>
          <button onClick={() => { setDrawerOpen(false); navigate("/grozs"); }} data-testid="drawer-view-cart-btn"
            className="w-full border-2 border-[#E2E2E2] hover:border-[#111111] hover:text-[#111111] font-semibold py-2.5 rounded-md transition-colors">Skatīt grozu</button>
        </div>
      </div>
    </div>
  );
};
